// @flow

import { TweenMax } from 'gsap';
import { useEffect, useRef } from 'react';
import styled, { type StyledComponent } from 'styled-components';

import { media } from '../../../styles/GlobalStyle';

type ImageLoaderProps = {
  className?: string,
  svg?: string,
  img: string,
  paddingRightVw?: number | null,
  isMobile?: boolean | null,
};

const RawImageLoader = ({
  className,
  svg,
  img,
  paddingRightVw,
  isMobile = false,
}: ImageLoaderProps) => {
  const imgSvg = useRef(null);
  const imgPng = useRef(null);

  const showRealCover = () => {
    TweenMax.to(imgPng.current, 0.5, {
      alpha: 1,
      onComplete: () => {
        TweenMax.to(imgSvg.current, 0.5, { alpha: 0 });
      },
    });
  };

  useEffect(() => {
    if (img) {
      TweenMax.set(imgPng.current, { alpha: 0 });
      const image: HTMLImageElement = new Image();
      image.src = img;
      image.addEventListener('load', showRealCover, false);

      return () => {
        image.removeEventListener('load', showRealCover);
      };
    }
    return () => {};
  }, [img]);

  const nameClass = `${String(className)} layerAnimation-img ${isMobile ? 'mobile' : 'desktop'}`;

  return (
    <div
      className={nameClass}
      style={paddingRightVw ? { paddingRight: `${paddingRightVw}vw` } : null}
    >
      <div className={'layerAnimation-img-cont'}>
        {svg && (
          <img
            ref={imgSvg}
            src={svg}
            alt={''}
          />
        )}
        <img
          ref={imgPng}
          src={img}
          alt={''}
        />
      </div>
    </div>
  );
};

export const ImageLoader: StyledComponent<ImageLoaderProps, {}, typeof RawImageLoader> = styled(
  RawImageLoader,
)`
  z-index: 1;
  position: relative;
  // padding-top: 5vh;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  top: -31px;
  ${media.greaterThan('desktop')`
    top: 0;
  `}

  .layerAnimation-img-cont {
    position: relative;
    text-align: right;
  }

  img:nth-child(2) {
    position: absolute;
    right: 0;
  }

  &.mobile {
    display: flex;
    justify-content: flex-end;
    img:nth-child(2) {
      // bottom: 0;
    }
  }

  img {
    z-index: 1;
    width: 100%;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    object-fit: contain;
    object-position: center top;
    padding: 0;

    ${media.lessThan('mobile')`
      object-fit: cover;
    `}

    ${media.greaterThan('desktop')`
      object-fit: contain;
      width: auto;
      height: 100%;
      object-fit: initial;
      object-position: initial;
      position: absolute;
      right: 0;
    `}
  }

  svg {
    ${media.greaterThan('desktop')`
      position: absolute;
      right: 0;
    `}
`;
